import { lazy, Suspense } from "react";
import CircularLoader from "../../customs/loader/main";

const Main = lazy(() => import("../../components/reports/upgradeRegister/main"));

const UpgradeReports = () => {
  return (
        <Suspense fallback={<CircularLoader />}>
          <Main />
        </Suspense>
  );
};

export default UpgradeReports;

